export default __webpack_public_path__ + "static/media/killerlogo.37159eae.png";